module.exports = __webpack_public_path__ + "img/unsepa.5b61fe88.svg";